import { render } from "./VideoBannerFive.vue?vue&type=template&id=62f1f7da"
import script from "./VideoBannerFive.vue?vue&type=script&lang=js"
export * from "./VideoBannerFive.vue?vue&type=script&lang=js"

import "./VideoBannerFive.vue?vue&type=style&index=0&id=62f1f7da&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__